import { v4 as uuidv4 } from "uuid";
export class PAFormDesignModel {
    constructor() {
        this.id = uuidv4();
        this.formName = "";
        this.hasResponses = false;
        this.createdOnAsString = "";
        this.isArchived = false;
        this.status = "";
        this.questionsCount = 0;
        this.questions = [];
    }
}
export default class FormDesign extends PAFormDesignModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
